// overlayUtils/themes.js

// SIZES
export const sizes = {
  tiny: {
    container: "w-40 relative border-2 rounded-3xl overflow-hidden",
    header: "border-b text-sm",
    body: "px-2.5 pb-2 rounded-b-3xl",          // max-h-52 
    description: "text-xs py-1 border-b",
    fieldCombo: "mt-1 py-0",
    label: "text-xs font-semibold",
    input: "text-[0.7em] border p-1 px-1.5 mt-1 rounded w-full outline-none focus:ring-1",
    chckbxLabel: "text-xs font-semibold",
    checkbox: "inline-block w-1/2 float-right mt-0.5",
    info: "",
    readyButton: 'mt-0 mb-0.5 text-[0.85em] w-full border font-medium py-0.5 rounded-md',
    button: {
      primary: 'mt-0 mb-0.5 text-[0.85em] w-full border font-medium py-0.5 rounded-md',
      secondary: 'mt-0 mb-0.5 text-[0.85em] w-full border font-medium py-0.5 rounded',
    },
    result: {
      container: 'my-0.5 border rounded-md',
      title: 'border-b-2 rounded-t-md text-[0.7em] font-semibold py-0.5',
      content: 'text-left text-[0.7em] py-1 p-2',
    },
    infoBox: {
      container: 'my-0.5 border-l-4 border rounded-md',
      title: 'border-b-2 rounded-t-md text-[0.7em] font-semibold py-0.5',
      content: 'text-left text-[11px] py-1 px-2',
    }
  },
  small: {
    container: "w-64 relative border-2 rounded-3xl overflow-hidden",
    header: "border-b text-[1.0em]",
    body: "px-2.5 pb-2 rounded-b-3xl",                // max-h-52 
    description: "text-xs py-1 border-b",
    label: "text-xs",
    fieldCombo: "mt-0.5 py-0",
    input: "text-[0.7em] border p-1 px-1.5 mt-1 rounded w-full outline-none focus:ring-1",
    chckbxLabel: "text-left text-xs",
    checkbox: "inline-block w-1/2 float-right mt-0.5",
    info: "w-4",
    readyButton: 'mt-0.5 mb-0.5 w-full border text-[0.9em] font-bold py-0.5 px-3 rounded-md',
    button: {
      primary: 'mt-0.5 mb-0.5 w-full border text-[0.9em] font-bold py-0.5 px-3 rounded-md',
      secondary: 'mt-0.5 mb-0.5 w-full border text-[0.9em] py-0.5 px-3 rounded-md',
    },
    result: {
      container: 'mt-1 mb-0.5 border rounded',
      title: 'border-b-2 rounded-t text-[0.8em] font-semibold py-0.5',
      content: 'text-left text-xs py-1 p-2',
    },
    infoBox: {
      container: 'mt-1 mb-0.5 border-l-4 border rounded',
      title: 'border-b-2 rounded-t text-[12px] font-semibold py-1',
      content: 'text-left text-[11px] py-1 px-2',
    }
  },
  medium: {
    container: "w-80 relative border-2 rounded-xl overflow-hidden",
    header: "border-b",
    body: "px-2.5 pb-2.5 rounded-b-xl",             // max-h-64 
    description: "text-xs py-1 border-b",
    fieldCombo: "mt-1 py-0",
    label: "text-xs font-semibold",
    input: "text-xs border p-1 px-1.5 mt-1.5 rounded w-full outline-none focus:ring-1",
    chckbxLabel: "text-xs font-semibold",
    checkbox: "inline-block w-1/2 float-right mt-0.5",
    info: "w-4",
    readyButton: 'mt-2 mb-0.5 w-full border font-medium py-0.5 px-3 rounded',
    button: {
      primary: 'mt-2 mb-0.5 w-full border font-medium py-0.5 px-3 rounded',
      secondary: 'mt-2 mb-0.5 w-full border font-medium py-0.5 px-3 rounded',
    },
    result: {
      container: 'mt-3.5 mb-0.5 border rounded',
      title: 'border-b-2 rounded-t text-[0.8em] font-semibold py-0.5',
      content: 'text-left text-xs py-1 p-2',
    },
    infoBox: {
      container: 'mt-3.5 mb-0.5 border-l-4 border rounded',
      title: 'border-b-2 rounded-t text-[0.8em] font-semibold py-1',
      content: 'text-left text-[0.8em] py-1 px-2',
    }
  },
  large: {
    container: "w-96 relative border-2 rounded-2xl overflow-hidden shadow-lg",
    header: "border-b font-md font-semibold",
    body: "px-2.5 pb-2.5 rounded-b-2xl",                    // max-h-80 
    description: "text-xs py-1 border-b",
    fieldCombo: "mt-1.5 py-0",
    label: "text-xs font-semibold",
    input: "text-xs border p-1 px-1.5 mt-1.5 rounded w-full outline-none focus:ring-1",
    info: "w-4",
    chckbxLabel: "text-xs font-semibold",
    checkbox: "inline-block w-1/2 float-right mt-0.5",
    readyButton: 'mt-3.5 mb-0.5 w-full border font-medium py-0.5 px-3 rounded',
    button: {
      primary: 'mt-3.5 mb-0.5 w-full border font-medium py-0.5 px-3 rounded',
      secondary: 'mt-3.5 mb-0.5  w-full border font-medium py-0.5 px-3 rounded',
    },
    result: {
      container: 'mt-3.5 mb-0.5 order rounded',
      title: 'border-b-2 rounded-t text-[0.8em] font-semibold py-1',
      content: 'text-left text-xs py-1 p-2',
    },
    infoBox: {
      container: 'mt-3.5 mb-0.5 border-l-4 border rounded',
      title: 'border-b-2 rounded-t text-[0.9em] font-semibold py-1',
      content: 'text-left text-[0.8em] py-1 px-2',
    }
  },
  xlarge: {
    container: "w-[30rem] relative border-2 rounded-lg overflow-hidden shadow-lg",
    header: "text-[1.2em] border-b font-medium",
    body: "px-3 pb-3 rounded-b-lg",                     // max-h-96 
    description: "text-xs py-1 border-b",
    fieldCombo: "mt-1.5 py-0",
    label: "text-[1em] font-semibold",
    input: "text-[0.9em] border p-1 px-1.5 mt-1.5 rounded w-full outline-none focus:ring-1",
    chckbxLabel: "text-[1em] font-semibold",
    checkbox: "inline-block w-1/2 float-right mt-0.5",
    info: "w-4",
    readyButton: 'mt-3.5 mb-0.5 w-full border font-medium py-0.5 px-3 rounded',
    button: {
      primary: 'mt-3 mb-0.5 w-full border font-medium py-0.5 px-3 rounded',
      secondary: 'mt-3 mb-0.5 w-full border font-medium py-0.5 px-3 rounded',
    },
    result: {
      container: 'mt-3.5 mb-0.5 border rounded',
      title: 'border-b-2 rounded-t text-[0.8em] font-semibold py-1',
      content: 'text-left text-xs py-1 p-2',
    },
    infoBox: {
      container: 'mt-3.5 mb-0.5 border-l-4 border rounded',
      title: 'border-b-2 rounded-t text-[0.8em] font-semibold py-1',
      content: 'text-left text-[0.8em] py-1 px-2',
    }
  }
};

// THEME STYLES
export const themeStyles = {
  "uplynk": {
    container: "border-[#FA53AE]",
    header: "bg-gray-800 bg-opacity-95 border-gray-600 text-white",
    body: "bg-gray-800 bg-opacity-80 backdrop-blur-sm",
    description: "bg-gray-900 bg-opacity-95 border-gray-600 text-gray-300",
    label: "text-gray-100",
    input: "bg-gray-900 border-gray-600 text-white focus:ring-2 focus:ring-[#FA53AE] focus:border-transparent",
    info: "opacity-50 hover:opacity-85 hover:font-semibold bg-gray-800 border-gray-400 z-10",
    chckbxLabel: "text-gray-100",
    checkbox: "",
    // readyButton: 'bg-[#022c0a] hover:bg-[#d5138a] active:bg-[#e5239a] border-[hsl(131,91%,20%)] hover:border-gray-400 text-white transition-colors duration-100',
    readyButton: 'bg-[#FB1FA7] border-[#FA53AE] hover:bg-[#d5138a] active:bg-[#e5239a] hover:border-[#FA53AE] text-white transition-colors duration-100',
    button: {
      primary: 'bg-[#b8006d] hover:bg-[#d5138a] active:bg-[#e5239a] border-[#FA53AE] hover:border-[#FA53AE] text-white transition-colors duration-100',
      secondary: 'bg-gray-950 border-gray-600 text-gray-300',
    },
    result: {
      container: 'border-gray-600',
      title: 'border-gray-600 bg-[#224462] text-gray-100',
      content: 'text-gray-300',
    },
    infoBox: {
      container: 'border-gray-600',
      title: 'border-gray-700 bg-[#224462] text-gray-100',
      content: 'text-gray-300',
    }
  },
  "cloud-ingest": {
    container: "border-indigo-600",
    header: "bg-indigo-950 bg-opacity-95 border-indigo-700 text-white font-medium",
    // body: "bg-gradient-to-b from-indigo-950 to-indigo-900 bg-opacity-95",
    body: "bg-gradient-to-b from-[rgba(30,27,75,0.85)] to-[rgba(49,46,129,0.85)] backdrop-blur-sm",
    description: "bg-indigo-950 bg-opacity-95 border-indigo-700 text-indigo-200",
    label: "text-gray-100",
    input: "bg-gray-800 border-indigo-600 text-white focus:ring-1 focus:ring-purple-500 focus:border-transparent",
    chckbxLabel: "text-gray-100",
    checkbox: "",
    info: "opacity-50 hover:opacity-85 hover:font-semibold bg-indigo-950 border-gray-400 z-10",
    readyButton: 'bg-[#01307b] border-[#0a408b] hover:bg-purple-700 active:bg-purple-600 hover:border-gray-400 text-white transition-colors duration-100',
    button: {
      primary: 'bg-indigo-800 hover:bg-purple-700 border-indigo-600 text-white',
      secondary: 'bg-gray-950 border-gray-500 text-gray-300',
    },
    result: {
      container: 'border-indigo-500',
      title: 'text-indigo-400 border-indigo-700 bg-indigo-900',
      content: 'bg-gray-800 text-gray-300',
    },
    infoBox: {
      container: 'bg-indigo-950 border-indigo-500',
      title: 'text-indigo-400 border-indigo-500',
      content: 'text-gray-300',
    }
  },
  "player": {
    container: "border-blue-600 shadow-lg",
    header: "bg-gradient-to-r from-blue-950 to-blue-900 bg-opacity-95 border-blue-600 text-white font-semibold",
    // body: "bg-gradient-to-r from-blue-950 to-blue-900 bg-opacity-95",
    body: "bg-gradient-to-r from-[rgba(2,6,23,0.85)] to-[rgba(30,58,138,0.85)] backdrop-blur-sm",
    description: "bg-blue-900 border-blue-600 text-blue-200 bg-opacity-95",
    label: "text-gray-100",
    input: "bg-blue-950 border-blue-500 text-white focus:ring-1 focus:ring-blue-400 focus:border-transparent",
    chckbxLabel: "",
    checkbox: "text-gray-100",
    info: "opacity-50 hover:opacity-85 hover:font-semibold bg-blue-950 border-gray-400 z-10",
    readyButton: 'bg-[#01307b] border-[#16465e] hover:bg-blue-600 active:bg-blue-500 hover:border-gray-400 text-white transition-colors duration-100',
    button: {
      primary: 'bg-blue-700 hover:bg-blue-600 border-blue-500 text-white',
      secondary: 'bg-gray-950 border-gray-500 text-gray-300',
    },
    result: {
      container: 'border-blue-700 shadow-md',
      title: 'border-blue-600 bg-blue-900 text-blue-100',
      content: 'bg-blue-950 text-blue-200',
    },
    infoBox: {
      container: 'border-blue-500 bg-blue-900 bg-opacity-50 shadow',
      title: 'text-blue-300 border-blue-600',
      content: 'text-blue-100',
    }
  },
  "transcode": {
    container: "border-violet-700",
    header: "bg-[#2b0548] bg-opacity-95 border-violet-700 text-white",
    // body: "bg-gradient-to-b from-[#2b0548] to-purple-950 bg-opacity-95",
    body: "bg-gradient-to-b from-[rgba(43,5,72,0.85)] to-[rgba(88,28,135,0.85)] backdrop-blur-sm",
    description: "bg-purple-950 bg-opacity-95 border-violet-600 text-violet-200",
    label: "text-gray-100",
    input: "bg-gray-800 border-violet-600 text-white focus:ring-1 focus:ring-violet-400 focus:border-transparent",
    chckbxLabel: "text-gray-100",
    checkbox: "",
    info: "opacity-50 hover:opacity-85 hover:font-semibold bg-purple-950 border-gray-400 z-10",
    readyButton: 'bg-[#4b2196] hover:bg-violet-700 active:bg-violet-600 border-gray-500 hover:border-gray-400 text-white',
    button: {
      primary: 'bg-violet-800 hover:bg-violet-700 border-violet-500 text-white',
      secondary: 'bg-gray-950 border-gray-500 text-gray-300',
    },
    result: {
      container: 'border-violet-600 shadow-lg',
      title: 'bg-purple-900 text-violet-200 border-violet-700',
      content: 'bg-[#2b0548] text-violet-100',
    },
    infoBox: {
      container: 'border-violet-500 bg-purple-900 bg-opacity-40 shadow',
      title: 'text-violet-300 border-violet-600',
      content: 'text-violet-100',
    }
  },
  "manifest": {
    container: "border-cyan-600",
    header: "bg-cyan-950 bg-opacity-95 border-cyan-700 text-white font-medium",
    // body: "bg-gradient-to-b from-cyan-950 to-cyan-900 bg-opacity-95",
    body: "bg-gradient-to-b from-[rgba(8,51,68,0.85)] to-[rgba(22,78,99,0.85)] backdrop-blur-sm",
    description: "bg-cyan-950 border-cyan-700 text-cyan-200 bg-opacity-95",
    label: "text-gray-100",
    input: "bg-gray-800 border-cyan-600 text-white focus:ring-1 focus:ring-cyan-400 focus:border-transparent",
    info: "opacity-50 hover:opacity-85 hover:font-semibold bg-cyan-950 border-gray-400 z-10",
    chckbxLabel: "text-gray-100",
    checkbox: "",
    readyButton: 'bg-cyan-700 hover:bg-cyan-600 active:bg-cyan-500 border-gray-500 hover:border-gray-400 text-white',
    button: {
      primary: 'bg-cyan-500 hover:bg-cyan-600 border-cyan-500 text-white',
      secondary: 'bg-gray-700 border-gray-500 text-gray-300',
    },
    result: {
      container: 'border-cyan-700',
      title: 'border-cyan-700 bg-cyan-900 text-cyan-100',
      content: 'bg-gradient-to-b from-cyan-950 to-cyan-900 text-cyan-200',
    },
    infoBox: {
      container: 'border-cyan-500 bg-cyan-900 bg-opacity-30',
      title: 'text-cyan-300 border-cyan-600',
      content: 'text-cyan-100',
    }
  }
};